<script lang="ts">
  import { CORP, GATE_COPY } from "@spacecrew/shared";
  import { gate } from "../net/gate.svelte.js";
  import { audio } from "../audio/bus.js";
  import { BUILD_LABEL } from "../lib/build.js";

  let code = $state("");
  const busy = $derived(gate.busy);
  const message = $derived(
    gate.error === "THROTTLED" ? GATE_COPY.throttled
    : gate.error === "OFFLINE" ? GATE_COPY.offline
    : gate.error === "REJECTED" ? GATE_COPY.rejected
    : "");

  async function submit(e: Event) {
    e.preventDefault();
    audio.unlock();
    const ok = await gate.submit(code.trim());
    audio.play(ok ? "ui.boot" : "ui.denied");
  }
</script>

<section class="gate" aria-labelledby="gate-title">
  <h1 id="gate-title">{CORP} // {GATE_COPY.title}</h1>
  <p class="dim">{GATE_COPY.body}</p>

  <form onsubmit={submit}>
    <label>{GATE_COPY.label}
      <!-- svelte-ignore a11y_autofocus -->
      <input class="code" bind:value={code} type="password" autocomplete="off" autocapitalize="off"
             spellcheck="false" required disabled={busy} autofocus />
    </label>
    <button type="submit" disabled={busy || !code.trim()}>{GATE_COPY.submit}</button>
  </form>

  <p class="status" role="status" aria-live="polite">
    {#if busy}CHECKING THE ROSTER…{:else if message}<span class="bad">{message}</span>{:else}&nbsp;{/if}
  </p>
  <p class="dim foot">{GATE_COPY.footer}</p>
  <p class="dim build">{BUILD_LABEL}</p>
</section>

<style>
  .gate { max-width: 52ch; padding: 0.2rem 0; }
  form { display: grid; gap: 0.6rem; margin-top: 0.8rem; }
  label { display: grid; gap: 0.3rem; }
  input { width: 100%; }
  .code { font-size: 1.4em; letter-spacing: 0.35em; text-align: center; }
  .status { min-height: 1.4em; margin-top: 0.6rem; }
  .foot { font-size: 0.8em; margin-top: 1.2rem; }
  .build { font-size: 0.72em; opacity: 0.6; }
</style>
